import PlaceFromScheduleStore from "./PlaceFromSchedule/PlaceFromScheduleStore";

/**
 * Host view stores for the yard area. The module ships no view stores of its
 * own to register (`yardManagementAppStores` is an empty array — its hub builds
 * what it needs internally), so this list carries only NTX's own screens.
 */
const yardManagementStoreList = [
  { name: "placeFromScheduleStore", store: PlaceFromScheduleStore },
];

export default yardManagementStoreList;
